<div class="boxContent">
    <h3>Angular component</h3>
    <div>input param: {{inputparameter}}</div>
    <button
        id="exampleDowngrade"
        type="button"
        class="main_btn"
        (click)="onClick()">
        <i class="fas fa-plus"></i>
    </button>
</div>
